// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/bg_2.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_main_section__hiBls {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 60vh;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .details_heroSection__KIeGw {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 5rem 0;
  }
}

.details_section__k4LVd img {
  margin-top: 1rem;
  max-width: 100%;
  height: auto;
}

.details_highlights_section__Gl6PI {
  margin: 4rem 0;

  .details_values__iW-Kk {
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;

    & h6 {
      color: #b4b4b4;
      font-family: Inter;
      font-size: 1.97rem;
      font-weight: 700;
    }

    & p {
      font-family: Inter;
      font-size: 1.1rem;
      font-weight: 500;
    }
  }
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  br {
    display: none;
  }

  .details_main_section__hiBls {
    height: 25vh;

    .details_heroSection__KIeGw {
      margin: 2rem 0;
    }
  }

  .details_highlights_section__Gl6PI {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .details_values__iW-Kk {
      padding: 1rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      & h6 {
        text-align: center;
      }

      & p {
        text-align: center;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ProjectDetails/details.module.css"],"names":[],"mappings":"AAAA;EACE,yDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;;EAEd;IACE,eAAe;IACf,aAAa;IACb,8BAA8B;;IAE9B;MACE,cAAc;MACd,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;;IAEZ;MACE,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,eAAe;MACf,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,8BAA8B;;MAE9B;QACE,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;MACpB;IACF;EACF;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/bg_2.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 60vh;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .heroSection {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin: 5rem 0;\n  }\n}\n\n.section img {\n  margin-top: 1rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.highlights_section {\n  margin: 4rem 0;\n\n  .values {\n    padding: 1rem 0;\n    display: flex;\n    justify-content: space-between;\n\n    & h6 {\n      color: #b4b4b4;\n      font-family: Inter;\n      font-size: 1.97rem;\n      font-weight: 700;\n    }\n\n    & p {\n      font-family: Inter;\n      font-size: 1.1rem;\n      font-weight: 500;\n    }\n  }\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  br {\n    display: none;\n  }\n\n  .main_section {\n    height: 25vh;\n\n    .heroSection {\n      margin: 2rem 0;\n    }\n  }\n\n  .highlights_section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .values {\n      padding: 1rem 0;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n\n      & h6 {\n        text-align: center;\n      }\n\n      & p {\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `details_main_section__hiBls`,
	"heroSection": `details_heroSection__KIeGw`,
	"section": `details_section__k4LVd`,
	"highlights_section": `details_highlights_section__Gl6PI`,
	"values": `details_values__iW-Kk`
};
export default ___CSS_LOADER_EXPORT___;
